import {
  OwnUpTextInput,
  OwnUpTextInputProps,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import styled from 'styled-components';

const OptionWrapper = styled.div`
  margin-top: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
`;

interface OptionProps extends NumericFormatProps<OwnUpTextInputProps> {
  label: JSX.Element;
  value: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const WidgetTextInput: React.FC<OptionProps> = ({ label, value, onChange, ...props }) => (
  <OptionWrapper>
    <NumericFormat
      {...props}
      customInput={OwnUpTextInput}
      labelPosition="outer"
      value={value}
      label={label}
      onChange={onChange}
      allowNegative={false}
      allowLeadingZeros={false}
    />
  </OptionWrapper>
);
